import './StatusChangedModal.scss'

import { Button, Modal } from 'react-bootstrap'
import { connectModal } from 'redux-modal'

import React from 'react'

const StatusChangedComponent = ({ handleHide, onConfirm, show }) => {
  const onClick = () => {
    handleHide()
    onConfirm()
  }

  return (
    <Modal className="StatusChangedModal" show={show}>
      <Modal.Body>
        <div className="StatusChangedModal__title">
            Status changed to ‘Met’
        </div>
        <div className="StatusChangedModal__message">
           Great job meeting your client! We&apos;ve progressed you to the ‘Met’ stage to give you credit.
        </div>
        <Button className="StatusChangedModal__button" onClick={onClick} bsStyle="info">Okay</Button>
      </Modal.Body>
    </Modal>
  )
}

const withModalHandlers = connectModal({ name: 'StatusChangedModal', destroyOnHide: false })

export const StatusChangedModal = withModalHandlers(StatusChangedComponent)
